module.exports = "/_next/static/images/d5459daec842b16555f0f990bd001ec8-money-box-icon.svg.webp";